const AFRICAN_COUNTRIES = [
    // { code: 'DZ', name: 'Algeria', currency: 'DZD' },
    { code: 'AO', name: 'Angola', currency: 'AOA' },
    // { code: 'BJ', name: 'Benin', currency: 'XOF' },
    { code: 'BW', name: 'Botswana', currency: 'BWP' },
    // { code: 'BF', name: 'Burkina Faso', currency: 'XOF' },
    { code: 'BI', name: 'Burundi', currency: 'BIF' },
    { code: 'CV', name: 'Cabo Verde', currency: 'CVE' },
    // { code: 'CM', name: 'Cameroon', currency: 'XAF' },
    // { code: 'CF', name: 'Central African Republic', currency: 'XAF' },
    // { code: 'TD', name: 'Chad', currency: 'XAF' },
    // { code: 'KM', name: 'Comoros', currency: 'KMF' }, // undefined
    // { code: 'CD', name: 'Democratic Republic of the Congo', currency: 'CDF' },
    // { code: 'CG', name: 'Republic of the Congo', currency: 'XAF' },
    // { code: 'CI', name: 'Côte d\'Ivoire', currency: 'XOF' },
    // { code: 'DJ', name: 'Djibouti', currency: 'DJF' }, // NAN
    { code: 'EG', name: 'Egypt', currency: 'EGP' },
    // { code: 'GQ', name: 'Equatorial Guinea', currency: 'XAF' },
    // { code: 'ER', name: 'Eritrea', currency: 'ERN' },  // NAN
    // { code: 'SZ', name: 'Eswatini', currency: 'SZL' },  // NAN
    { code: 'ET', name: 'Ethiopia', currency: 'ETB' },
    // { code: 'GA', name: 'Gabon', currency: 'XAF' },
    { code: 'GM', name: 'Gambia', currency: 'GMD' },
    { code: 'GH', name: 'Ghana', currency: 'GHS' },
    { code: 'GN', name: 'Guinea', currency: 'GNF' },
    // { code: 'GW', name: 'Guinea-Bissau', currency: 'XOF' },
    { code: 'KE', name: 'Kenya', currency: 'KES' },
    // { code: 'LS', name: 'Lesotho', currency: 'LSL' },
    { code: 'LR', name: 'Liberia', currency: 'LRD' },
    // { code: 'LY', name: 'Libya', currency: 'LYD' },   // NAN
    { code: 'MG', name: 'Madagascar', currency: 'MGA' },
    // { code: 'MW', name: 'Malawi', currency: 'MWK' }, // undefined
    // { code: 'ML', name: 'Mali', currency: 'XOF' },
    // { code: 'MR', name: 'Mauritania', currency: 'MRU' }, // undefined
    // { code: 'MU', name: 'Mauritius', currency: 'MUR' }, // undefined
    // { code: 'YT', name: 'Mayotte', currency: 'EUR' }, // undefined
    // { code: 'MA', name: 'Morocco', currency: 'MAD' }, // undefined
    // { code: 'MZ', name: 'Mozambique', currency: 'MZN' }, // undefined
    // { code: 'NA', name: 'Namibia', currency: 'NAD' }, // undefined
    // { code: 'NE', name: 'Niger', currency: 'XOF' },
    // { code: 'NG', name: 'Nigeria', currency: 'NGN' }, // undefined
    // { code: 'RE', name: 'Réunion', currency: 'EUR' }, // undefined
    // { code: 'RW', name: 'Rwanda', currency: 'RWF' }, // undefined
    // { code: 'ST', name: 'São Tomé and Príncipe', currency: 'STN' }, // undefined
    // { code: 'SN', name: 'Senegal', currency: 'XOF' },
    // { code: 'SC', name: 'Seychelles', currency: 'SCR' }, // undefined
    // { code: 'SL', name: 'Sierra Leone', currency: 'SLL' }, // undefined
    // { code: 'SO', name: 'Somalia', currency: 'SOS' } // undefined,
    // { code: 'ZA', name: 'South Africa', currency: 'ZAR' }, // undefined
    // { code: 'SS', name: 'South Sudan', currency: 'SSP' }, // undefined
    // { code: 'SD', name: 'Sudan', currency: 'SDG' },
    // { code: 'TZ', name: 'Tanzania', currency: 'TZS' } // undefined,
    // { code: 'TG', name: 'Togo', currency: 'XOF' },
    // { code: 'TN', name: 'Tunisia', currency: 'TND' },
    // { code: 'UG', name: 'Uganda', currency: 'UGX' }, // undefined
    // { code: 'EH', name: 'Western Sahara', currency: 'MAD' }, // undefined
    // { code: 'ZM', name: 'Zambia', currency: 'ZMW' }, // undefined
    // { code: 'ZW', name: 'Zimbabwe', currency: 'ZWL' }, // undefined
];

export default AFRICAN_COUNTRIES;